<div class="m-subheader">
  <div class="mr-auto">
    <h3 class="m-subheader__title">
      {{ 'sales.statistics.client' | transloco }}
    </h3>
    <span></span>
    <hx-date-range-select [onlyPastDates]="true" class="date-align" [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'sales.statistics.store' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>
            <div class="filter">
              <small>{{ 'sales.searchByPhoneOrClient' | transloco }}</small>
              <input type="text" required [(ngModel)]="params.query" (keyup)="onQueryChanged()" name="query"
                     class="form-control m-input" [placeholder]="'sales.searchByPhoneOrClient' | transloco">
            </div>
          </div>
          <div class="m_datatable m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 block-table-scroll">
            <table class="m-datatable__table" *ngIf="sales.length && !isloading.sales">
              <thead class="m-datatable__head">
              <tr class="m-datatable__row m-datatable__row--head">
                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.client' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.phone' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.store' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.without-discount' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.delivery' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.pickup' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.cash' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.pos' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.forte' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.kaspi' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.kaspi-pos' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.coins' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.checking-account' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.discount' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.profit' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.receipts' | transloco }}</span>
                </th>

                <th class="m-datatable__cell">
                  <span>{{ 'sales.table.average-receipt' | transloco }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
              <tr *ngFor="let even = even; let i = index; let item of sales"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                <td class="m-datatable__cell">
                  <a *ngIf="item.clientFullname" [title]="item.clientFullname" [routerLink]="['../sales/client']" [queryParams]="{dateFrom: params.date?.from, dateTo: params.date?.to, clientId: item.clientId, clientFullname: item.clientFullname }">
                    {{ item.clientFullname }}
                  </a>
                </td>

                <td class="m-datatable__cell">
                  {{ item.clientPhone }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.storeTitle | uiLabel }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.subTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.deliveryTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.pickupTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.cashTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.posTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.forteTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.kaspiTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.kaspiPosTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.coinTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.checkingAccountTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ item.discountTotal | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ (item.total - item.costPriceTotral) | fixed:2 | moneyFormat | uiCurrency: item.currency }}
                </td>

                <td class="m-datatable__cell">
                  {{ item.receiptsTotal  }}
                </td>

                <td class="m-datatable__cell min-width-100">
                  {{ ( item.total / item.receiptsTotal)  | fixed:2 |  moneyFormat | uiCurrency: item.currency }}
                </td>

              </tr>
              </tbody>
            </table>

            <hx-loader [length]="sales.length" [isLoading]="isloading.sales"></hx-loader>

            <br/>
            <br/>

            <div class="m--align-center" *ngIf="sales.length && !isloading.sales && pagination.allItemCount > 0">
              <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                              [(page)]="params.page" [pageSize]="params.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
